










import { Component, Prop, Vue } from "vue-property-decorator";
import Button from "@/components/Table/WeekSwitcher/Button.vue";
@Component({
  components: { Button }
})
export default class WeekSwitcher extends Vue {
  @Prop() readonly weekStart!: string;
  @Prop() readonly weekEnd!: string;
  @Prop() readonly changeWeek!: Function;
}
